import { useEffect, useState } from "react";
import { api, formatErr } from "../../lib/api";
import { toast } from "sonner";

export default function AdminTryouts() {
    const [items, setItems] = useState([]);

    const load = async () => {
        const { data } = await api.get("/tryouts");
        setItems(data);
    };
    useEffect(() => { load(); }, []);

    const setStatus = async (id, status) => {
        try {
            await api.put(`/tryouts/${id}/status?status=${status}`);
            toast.success("Updated");
            load();
        } catch (err) { toast.error(formatErr(err)); }
    };

    const del = async (id) => {
        if (!window.confirm("Delete?")) return;
        try {
            await api.delete(`/tryouts/${id}`);
            load();
        } catch (err) { toast.error(formatErr(err)); }
    };

    return (
        <div data-testid="admin-tryouts">
            <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-2">Manage</div>
            <h1 className="h-display text-4xl mb-8">Tryout Applications</h1>
            <div className="card-flat overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-bg-soft border-b border-line">
                        <tr>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Player</th>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Position</th>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Age / Ht</th>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Contact</th>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Payment</th>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Status</th>
                            <th className="text-right p-3 text-[10px] uppercase tracking-widest text-ink">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((t) => (
                            <tr key={t.id} className="border-t border-line">
                                <td className="p-3">
                                    <div className="text-white">{t.player_name}</div>
                                    <div className="text-ink text-xs">{new Date(t.created_at).toLocaleDateString()}</div>
                                </td>
                                <td className="p-3 text-ink">{t.position}</td>
                                <td className="p-3 text-ink">{t.age} / {t.height}</td>
                                <td className="p-3 text-ink">
                                    <div>{t.email}</div>
                                    <div className="text-xs">{t.phone}</div>
                                </td>
                                <td className="p-3">
                                    <span className={`text-xs px-2 py-1 ${t.payment_status === "paid" ? "bg-green-900 text-green-300" : "bg-bg-soft text-ink"}`}>
                                        {t.payment_status}
                                    </span>
                                </td>
                                <td className="p-3">
                                    <select value={t.status} onChange={(e) => setStatus(t.id, e.target.value)} className="text-xs px-2 py-1" data-testid={`tryout-status-${t.id}`}>
                                        <option value="pending">pending</option>
                                        <option value="paid">paid</option>
                                        <option value="reviewed">reviewed</option>
                                        <option value="accepted">accepted</option>
                                        <option value="rejected">rejected</option>
                                    </select>
                                </td>
                                <td className="p-3 text-right">
                                    <button onClick={() => del(t.id)} className="text-red-400 text-xs uppercase">Delete</button>
                                </td>
                            </tr>
                        ))}
                        {items.length === 0 && (
                            <tr><td colSpan={7} className="p-12 text-center text-ink">No applications yet.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
